import { render, staticRenderFns } from "./ProOTPPage.vue?vue&type=template&id=fdb70a8e"
import script from "./ProOTPPage.vue?vue&type=script&lang=js"
export * from "./ProOTPPage.vue?vue&type=script&lang=js"
import style0 from "./ProOTPPage.vue?vue&type=style&index=0&id=fdb70a8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports